import { BackLink } from '@arcadiapower/shrike';
import { DashboardButton } from '~/components/dashboard-button';
import { type ImageType, ImageSelector, GREEN_HOME } from '~/components/image';
import { TwoColumnGrid } from '~/components/layout';
import { Description, Title } from '~/components/typography';
import { useCopy } from '~/hooks/use-copy';

export const Dashboard = ({ context, onBack, overrideCopy }: DashboardProps) => {
  const copy = useCopy(context, defaultCopy, overrideCopy);

  return (
    <TwoColumnGrid testId="screen-Dashboard">
      <TwoColumnGrid.Navigation>
        <BackLink openInNewTab={false} onClick={onBack}>
          {copy.backButton}
        </BackLink>
      </TwoColumnGrid.Navigation>
      <TwoColumnGrid.Primary>
        <Title>{copy.title}</Title>
        <Description mb={5}>{copy.description}</Description>
        <DashboardButton userId={context.userId}>{copy.dashboardButton}</DashboardButton>
      </TwoColumnGrid.Primary>
      <TwoColumnGrid.Secondary centered>
        <ImageSelector type={copy.imageType} />
      </TwoColumnGrid.Secondary>
    </TwoColumnGrid>
  );
};

export const defaultCopy = () => {
  return {
    title: "You're all set!",
    description:
      'Everything looks good on your utility and payment information. Next, we’ll double-check your eligibility and then find you a spot on a community solar farm. In the meantime we’ll share efficiency tips and keep you updated on the latest in clean energy and you’ll have access to our advocacy tools from your dashboard.',
    imageType: GREEN_HOME as ImageType,
    dashboardButton: 'Go to my dashboard',
    backButton: 'Back',
  };
};

export type DashboardCopy = ReturnType<typeof defaultCopy>;

export interface DashboardProps {
  context: DashboardContext;
  onBack: () => void;
  overrideCopy?: (context: DashboardContext) => Partial<DashboardCopy>;
}

export interface DashboardContext {
  userId: number;
}
